export default "__VITE_ASSET__DhUz8Ugc__"